import { Tooltip } from "@mui/material";
import { GridActionsCellItem } from "@mui/x-data-grid";

import CallSplitIcon from "@mui/icons-material/CallSplit";
import { useState } from "react";
import SplitModal from "../modals/SplitModal";
import { Ownership } from "../../../../apis/__generated__/graphql";

export interface SplitProps {
  refetch: () => void;
  row?: Ownership;
  disabled: boolean;
  onSelectedRow: () => void;
  onUnselectedRow: () => void;
}

export default function SplitButton({
  refetch,
  row,
  disabled,
  onSelectedRow,
  onUnselectedRow,
}: SplitProps) {
  const [open, setOpen] = useState(false);

  const handleOpen = () => {
    setOpen(true);
    onSelectedRow();
  };

  const handleClose = () => {
    setOpen(false);
    onUnselectedRow();
  };

  return (
    <>
      <GridActionsCellItem
        label="split"
        icon={
          <Tooltip title="Split">
            <CallSplitIcon />
          </Tooltip>
        }
        onClick={handleOpen}
        disabled={disabled}
      />
      {row && (
        <SplitModal
          row={row}
          open={open}
          onClose={handleClose}
          refetch={refetch}
        />
      )}
    </>
  );
}
